import { turnoverWrite as sqlWrite } from "../../utils/sqlClient";
import { fmtDate } from "./shared";

export default function ActionItemRow({ item, turnoverID, onUpdated }) {
  async function markDone() {
    try {
      const payload = JSON.stringify({
        action_item_id: item.ActionItemID,
        turnover_id:    turnoverID,
        is_complete:    true,
      }).replace(/'/g, "''");
      await sqlWrite(`EXEC sp_SaveTurnoverActionItem @payload = '${payload}'`);
      onUpdated();
    } catch (e) { alert("Error: " + e.message); }
  }

  return (
    <div style={{
      display: "flex", alignItems: "flex-start", gap: 10,
      padding: "10px 0", borderBottom: "1px solid var(--cs-border)",
    }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 13, color: "var(--text)" }}>
          {item.Description}
        </div>
        <div style={{ display: "flex", gap: 12, marginTop: 3 }}>
          {item.AssignedTo && <span style={{ fontSize: 11, color: "var(--text3)" }}>→ {item.AssignedTo}</span>}
          {item.DueDate && <span style={{ fontSize: 11, color: "#dc2626" }}>Due {fmtDate(item.DueDate)}</span>}
        </div>
      </div>
      <button onClick={markDone} style={{
        flexShrink: 0, padding: "4px 12px", fontSize: 12, fontWeight: 600,
        border: "1px solid var(--cs-border)", borderRadius: 6,
        background: "var(--surface)", color: "var(--text2)", cursor: "pointer",
      }}>
        Done
      </button>
    </div>
  );
}
